import { jsx } from "react/jsx-runtime";
import { useTranslation } from "@crehana/i18n";
import { useListManager } from "../list-actions-layout/index.js";
import i18n from "./i18n/index.js";
import { SegmentationFieldInput } from "./segmentation-field.js";
function SegmentationFieldGroup({ onCategorySelect, categories, onFieldSelect, onChange, defaultValues = [], onViewAffectedUsers }) {
    const { languageCode } = useTranslation();
    const [ListActionsLayout, listProps] = useListManager({
        onChange,
        defaultValues
    });
    return /*#__PURE__*/ jsx(ListActionsLayout, {
        ...listProps,
        footerActions: /*#__PURE__*/ jsx("button", {
            type: "button",
            className: "tw-mt-2.4 tw-btn-tertiary-xs disabled:tw-pointer-events-none disabled:tw-opacity-50",
            onClick: onViewAffectedUsers,
            disabled: !listProps.canDeleteAll,
            children: i18n[languageCode].VIEW_USERS_IN_SEGMENT
        }),
        children: ({ onChange: onItemChange, onDelete, defaultValue })=>/*#__PURE__*/ jsx(SegmentationFieldInput, {
                onCategorySelect: onCategorySelect,
                categories: categories,
                onFieldSelect: onFieldSelect,
                onChange: onItemChange,
                onDelete: onDelete,
                defaultValue: defaultValue
            })
    });
}
export { SegmentationFieldGroup };
